import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ReplaySubject} from "rxjs";

@Injectable()
export class FUIPageService {
    private _minimise: ReplaySubject<boolean>;
    public minimise$: Observable<boolean>;

    constructor() {
        this._minimise = new ReplaySubject<boolean>(1);
        this.minimise$ = this._minimise.asObservable();
    }

    /**
     * Minimise the view due to restricted size of the viewport
     * @param {boolean} minimise
     */
    public minimise(minimise: boolean): void {
        this._minimise.next(minimise);
    }
}
